import { agreementAndPostAgreementDocsLabelsAndValues } from '../../../utils/coco-acquired.config';
export const cocoBuiltAgreementAndPostAgreementDocsValidation = (
  formDetails,
  docsCheck
) => {
  let monthlyRentMgStartYearCheck = false;
  let monthlyRentRevenueShareOnDineInStartYearCheck = false;
  let monthlyRentRevenueShareOnDeliveryInStartYearCheck = false;
  let landlordCheck = false;
  let leaseAddressCheck = false;
  let camCheck = false;
  const documentType = formDetails?.documentType?.value;
  const isMonthlyRentMgStartYear =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isMonthlyRentMgStartYear) {
    monthlyRentMgStartYearCheck = !formDetails.monthlyRentMgStartYear?.trim();
  }
  const isMonthlyRentRevenueShareOnDineInStartYear =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isMonthlyRentRevenueShareOnDineInStartYear) {
    monthlyRentRevenueShareOnDineInStartYearCheck =
      !formDetails.monthlyRentRevenueShareOnDineInStartYear?.trim();
  }
  const isMonthlyRentRevenueShareOnDeliveryInStartYear =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isMonthlyRentRevenueShareOnDeliveryInStartYear) {
    monthlyRentRevenueShareOnDeliveryInStartYearCheck =
      !formDetails.monthlyRentRevenueShareOnDeliveryInStartYear?.trim();
  }

  const isLandlord =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isLandlord) {
    landlordCheck = !formDetails.landlord?.trim();
  }
  const isLeaseAddress =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isLeaseAddress) {
    leaseAddressCheck = !formDetails.leaseAddress?.trim();
  }
  const isCAM =
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement ||
    documentType ===
      agreementAndPostAgreementDocsLabelsAndValues.optionAgreement;
  if (isCAM) {
    camCheck = !formDetails.cam?.trim();
  }
  let leaseAgreementCheck = false;
  const isleaseAgreement =
    documentType ===
    agreementAndPostAgreementDocsLabelsAndValues.leaseAgreement;
  if (isleaseAgreement) {
    leaseAgreementCheck =
      !formDetails?.landlordInvestment ||
      !formDetails?.rsecdeposit ||
      !formDetails?.rsecdepositinmonths ||
      !formDetails?.rentRevShareDeliveryExcludesAggregatorsComission;
  } else if (
    documentType ===
    agreementAndPostAgreementDocsLabelsAndValues.optionAgreement
  ) {
    leaseAgreementCheck =
      !formDetails?.rsecdeposit ||
      !formDetails?.rsecdepositinmonths ||
      !formDetails?.rentRevShareDeliveryExcludesAggregatorsComission;
  }
  let endDateCheck =
    formDetails?.documentType?.value ===
      agreementAndPostAgreementDocsLabelsAndValues.submissionOfRegHardCopy ||
    formDetails.notApplicable
      ? false
      : !formDetails.endDate;

  let startDateCheck = formDetails.notApplicable
    ? false
    : !formDetails.startDate;

  return (
    docsCheck ||
    monthlyRentMgStartYearCheck ||
    monthlyRentRevenueShareOnDineInStartYearCheck ||
    monthlyRentRevenueShareOnDeliveryInStartYearCheck ||
    landlordCheck ||
    leaseAddressCheck ||
    camCheck ||
    // !formDetails.documentDate ||
    !formDetails.documentType ||
    startDateCheck ||
    endDateCheck ||
    leaseAgreementCheck
  );
};

export const cocoBuiltMfaRiderValidation = (formDetails, docsCheck) => {
  const dateCheck = formDetails.notApplicable
    ? false
    : !formDetails.endDate || !formDetails.startDate;
  return docsCheck || dateCheck || !formDetails.documentType;
};
export const nocForGstCocoBuilt = (formDetails, docsCheck) => {
  const landlordNameMissing = !formDetails.nameOfLandload;
  const addressMissing = !formDetails.address;
  return landlordNameMissing || addressMissing || docsCheck;
};
export const electricityBillInNameOfLandloadCocoBuilt = (
  formDetails,
  docsCheck
) => {
  const landlordNameMissing = !formDetails.nameOfLandload;
  const addressMissing = !formDetails.address;
  return landlordNameMissing || addressMissing || docsCheck;
};
export const cocoBuiltPreAgreementDocsValidation = (formDetails, docsCheck) => {
  const dateCheck = formDetails.notApplicable ? false : !formDetails.startDate;
  return docsCheck || !formDetails.documentType || dateCheck;
};
